import request from '@/utils/request'

export function addExchange(data) {
    return request({
        url: '/acode/api/exchange/add',
        method: 'post',
        data
    })
}

export function updateExchange(data) {
    return request({
        url: '/acode/api/exchange/phone/update/status',
        method: 'put',
        data
    })
}

export function getExchangeList(data) {
    return request({
        url: '/acode/api/exchange/phone/page',
        method: 'post',
        data
    })
}


export function getExchangeListAll(params) {
    return request({
        url: '/acode/api/exchange/listAll',
        method: 'get',
        params
    })
}

